<template>
  <div class="order-list" @click="show = false">
    <div class="title">
      <div class="search">
        <van-search type="digit" v-model="mobile" placeholder="请输入下单人手机号" @input="input" />
      </div>
      <div class="more">
        <!-- <van-icon name="more-o" size="28" style="font-weight: 600;" color="#0B7EFF" @click.stop="show = true" /> -->
        <img src="https://images.snsports.cn/Fpsy1sF7ojnaWm2UlArIo6K3rkKw" @click.stop="show = true" />
        <div class="my-popup" v-show="show">
          <div @click="goPage">活动设置 <van-icon name="setting-o" /></div>
          <div class="line"></div>
          <div @click="goActivity">前往活动页<van-icon name="share-o" /></div>
        </div>
      </div>
    </div>
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="getPlayerCardOrderList()">
        <div class="item" v-for="item in list" :key="item.orderId">
          <div class="order-title">{{ item.orderId }} <span>{{ getStatus(item.orderStatus, item.refundApplyStatus)
          }}</span></div>
          <div class="box">
            <div class="img">
              <img :src="imageView(item.photoA, 204, 275)" @click="openShow(item)" />
              <div class="mian">共{{ item.photoB ? '2' : '1' }}面</div>
            </div>
            <div class="info">
              <div class="name">{{ getName(item.templateId) }}</div>
              <div class="type">{{ item.cardType }}</div>
              <div class="type">{{ item.userMobile }}</div>
            </div>
            <div class="price-box">
              <div class="price">{{ (item.userPayment / 100).toFixed(2) }}</div>
              <div class="but" @click="goOrder(item.orderId)">订单详情</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-if="list.length === 0">
      <van-empty description="暂无活动订单" />
      <div class="kong">
        <van-button round type="info" @click="copy">复制活动链接</van-button>
        <van-button round type="info" @click="goActivity">前往活动页</van-button>
      </div>
    </div>
    <van-popup v-model="showPopup">
      <div style="display: flex;padding: 12px;">
        <div>
          <img :src="imageView(imgUrl.photoA, 102, 135)" />
          <div class="but" style="text-align: center;" @click="viewImages(imgUrl.photoA)">下载A面</div>
        </div>
        <div v-if="imgUrl.photoB" style="margin-left: 8px;">
          <img :src="imageView(imgUrl.photoB, 102, 135)" />
          <div class="but" style="text-align: center;" @click="viewImages(imgUrl.photoB)">下载B面</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Search, Icon, List, Empty, Toast, Popup } from 'vant';
Vue.use(Search).use(Icon).use(List).use(Empty).use(Toast).use(Popup);
import { getPlayerCardOrderList } from '@/api/match'
import { QNImageUtil } from "@/utils";
import { playerList, matchCardList } from '@/utils/player-data'
// import { viewImages } from '@/libs/ds-bridge'
import { AppType } from '@/constants/appType'

export default {
  data() {
    return {
      mobile: '',
      resellerId: '',
      unionMatchId: '',
      objType: '',
      list: [],
      show: false,
      showPopup: false,
      loading: false,
      finished: false,
      pageNum: 1,
      playerCardList: [...playerList, ...matchCardList],
      imgUrl: { photoA: '', photoB: '' }
    };
  },
  mounted() {
    this.resellerId = this.$route.query.resellerId
    this.objType = this.$route.query.objType
    this.unionMatchId = this.$route.params.unionMatchId
    // this.getPlayerCardOrderList()
  },
  methods: {
    openShow(item) {
      if (AppType.isInApp()) {
        this.imgUrl.photoA = item.photoA
        this.imgUrl.photoB = item.photoB
        this.showPopup = true
      }
    },
    viewImages(img) {
      const url = this.imageView(img, 0, 0)
      const a = document.createElement('a')
      a.href = url
      document.body.append(a)
      a.click()
      document.body.removeChild(a)
      // viewImages(url)
    },
    getPlayerCardOrderList() {
      getPlayerCardOrderList({ resellerId: this.resellerId, pageNum: this.pageNum, mobile: this.mobile }).then(res => {
        this.pageNum += 1;
        this.list = res.data.list
        if (res.data.list.length < 10) {
          this.finished = true
        }
        this.loading = false
      })
    },
    getStatus(statu, refundApplyStatus) {
      if (statu === 1) {
        if (refundApplyStatus === -2) return '已支付'
        if (refundApplyStatus === 0) return '待审核'
        if (refundApplyStatus === -1) return '拒绝'
        if (refundApplyStatus === 1) return '同意'
      } else if (statu === 2) {
        return '退款中'
      } else if (statu === 3) {
        return '已退款'
      }
    },
    goPage() {
      this.$router.push({ path: `/match-manage/set-player-card/${this.unionMatchId}?objType=${this.objType}` }) // 
    },
    goOrder(id) {
      this.$router.push({ name: 'SaasOrderDetail', query: { id } })
    },
    goActivity() {
      if (process.env.VUE_APP_ENV === 'stage') {
        window.location.href = `https://www.snsports.cn/webapp-bmb-stage/index.html#/saas-player/home?resellerId=${this.resellerId}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp-bmb/index.html#/saas-player/home?resellerId=${this.resellerId}`
      }
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    getName(id) {
      if(id == 137) return ''
      const obj = this.playerCardList.find(item => item.id == id)
      if (obj) {
        return obj.model
      } else {
        return
      }
    },
    input() {
      this.pageNum = 1;
      this.getPlayerCardOrderList()
    },
    copy() {
      let url = ''
      console.log(process.env);
      if (process.env.VUE_APP_ENV === 'stage') {
        url = `https://www.snsports.cn/webapp-bmb-stage/index.html#/saas-player/home?resellerId=${this.resellerId}`
      } else {
        url = `https://www.snsports.cn/webapp-bmb/index.html#/saas-player/home?resellerId=${this.resellerId}`
      }
      const textarea = document.createElement("textarea");

      // 将文本设置为textarea的值  
      textarea.value = url;

      // 将textarea添加到文档中  
      document.body.appendChild(textarea);

      // 选择textarea中的文本  
      textarea.select();

      try {
        // 复制选中的文本到剪贴板  
        document.execCommand("copy");
        Toast("复制成功！");
        document.body.removeChild(textarea);
      } catch (err) {
        Toast("复制失败：", err);
        document.body.removeChild(textarea);
      }
    }
  },
};
</script>

<style scoped lang="scss">
.order-list {
  background-color: #F9F9F9;
  min-height: 100vh;

  .kong {
    display: flex;
    justify-content: space-around;
  }

  .title {
    padding: 12px;
    padding-left: 0px;
    background-color: #fff;
    display: flex;
    align-items: center;

    .search {
      flex: 1;
    }

    .more {
      position: relative;
      img{
        width: 24px;
        height: 20px;
      }
      .my-popup {
        width: 120px;
        position: absolute;
        left: -120px;
        background-color: #eaeaea;
        border-radius: 4px;
        padding: 4px 6px;

        div {
          padding: 6px 0;
          display: flex;
          justify-content: space-between;
        }

        .line {
          width: 100%;
          padding: 0;
          height: 1px;
          background-color: #333;
        }
      }
    }
  }

  .list {
    .item {
      background-color: #fff;
      margin-bottom: 12px;

      .order-title {
        padding: 8px;
        font-size: 12px;
        color: #D7D7D7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #a7a7a7;

        span {
          font-size: 13px;
          color: #002FA7;
        }
      }

      .box {
        padding: 12px;
        display: flex;

        .img {
          margin-right: 12px;
          background: #F5F5F5;
          width: 80px;

          img {
            width: 100%;
          }

          .mian {
            text-align: center;
            background: #fff;
            font-size: 12px;
            padding-top: 4px;
          }
        }

        .info {
          flex: 1;

          .name {
            margin-bottom: 4px;
            margin-top: 6px;
            font-size: 15px;
          }

          .type {
            color: #a7a7a7;
            margin-top: 10px;
            font-size: 12px;
          }
        }

        .price-box {
          height: 130px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .price {
            margin-bottom: 4px;
            margin-top: 6px;
            font-size: 15px;
            color: #a7a7a7;
            text-align: right;
          }

          .but {
            color: #fff;
            background: #002FA7;
            font-size: 14px;
            border-radius: 16px;
            padding: 6px 12px;
          }
        }

      }
    }
  }

  .but {
    color: #fff;
    background: #002FA7;
    font-size: 14px;
    border-radius: 16px;
    padding: 6px 12px;
  }
}
</style>
